<template>
    <div class="container">
        <van-list
            v-if="listShow"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            offset="10"
            @load="onLoad"
        >
            <list-com  v-for="(item, i) in lists" :key="i" :item="item" ></list-com>
        </van-list>
        <van-empty
          v-else
          class="custom-image"
          image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无数据"
        />
    </div>
</template>
<script>
import listCom from './listCom'
import { getSignRecordByPage } from '@api/lishui/active'
import { Toast } from 'vant'
export default {
  data() {
    return {
      listShow: true,
      loading: true,
      finished: false,
      lists: [],
      pageSize: 10,
      pageNum: 1
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      getSignRecordByPage(params).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          if (data.results) {
            data.results.forEach(item => {
              switch (item.status) {
                case 1:
                  item.statusText = '未开始'
                  break
                case 2:
                  item.statusText = '进行中'
                  break
                case 3:
                  item.statusText = '已结束'
                  break
              }
              this.lists.push(item)
            })
          }
          this.loading = false
          if (!data.results || data.results.length < 10) {
            this.finished = true
          } else {
            this.finished = false
          }
          if (this.lists.length == 0) {
            this.listShow = false
          } else {
            this.listShow = true
          }
        } else {
          Toast(msg)
        }
      })
    },
    // 触底加载更多
    onLoad() {
      this.pageNum++
      this.getList()
    }
  },
  components: {
    listCom
  }
}
</script>
<style lang="scss" scoped>
.container{
    padding:10px 0 58px;
    background:#fff;
}
/deep/.custom-image .van-empty__image {
  width: 90px;
  height: 90px;
  margin-top:40%;
}
</style>
